import { getCompanyExperiments } from './Amalgam';

const PRODUCT_TYPE = {
  BASIC: 'BASIC',
  JEWELLERY: 'JEWELLERY',
  JEWELLERY_B2C: 'JEWELLERY'
};

export const getOrderConfirmationCustomMessage = () =>
  getCompanyExperiments().orderConfirmationCustomMessage;

export const getRequestLeadIdentity = () => getCompanyExperiments().requestLeadIdentity;

export const getChatWidgetIdentityToken = () => {
  const token = getCompanyExperiments().chatWidgetIdentityToken;

  if (!token) {
    return '';
  }

  return `\n\nInquiry code: #${token}`;
};

export const showPoweredByResellship = () =>
  getCompanyExperiments().showPoweredByResellship !== false;

export const getCompanyProductType = () => getCompanyExperiments().productType;

export const isJewelleryB2CTypeProduct = () =>
  getCompanyProductType() === PRODUCT_TYPE.JEWELLERY_B2C;

export const getProductImageTileSize = () => getCompanyExperiments().productTileImageSize || '400';

export const shouldHideCompanyNameFromCatalogueHeader = () =>
  getCompanyExperiments().hideCompanyNameFromCatalogueHeader || false;

export const shouldCenterAlignCompanyNameAndLogoInCatalogueHeader = () =>
  getCompanyExperiments().centerAlignCompanyNameAndLogoInCatalogueHeader || false;
